/// <amd-module name="typeahead/core/logging/TypeaheadInteractionMetric" />

import {TypeaheadMetric} from "typeahead/core/logging/TypeaheadMetric";
import {Suggestion} from "typeahead/core/Suggestion";

export class TypeaheadInteractionMetric extends TypeaheadMetric {
    public readonly suggestionSelected: boolean;
    private inputLength: number;
    private selectionDepth: string;

    constructor(
        lob: string,
        elementId: string,
        private readonly userTypedQuery: string,
        private readonly suggestionShown: boolean,
        selectedSuggestion: Suggestion,
        private readonly childSuggestionsExpanded: boolean,
        private readonly areChildrenPresent: boolean,
        activeESSTests: string,
        private readonly zeroResults: boolean,
        private readonly error: string,
        private readonly isAddrAutocomplete: boolean,
        private readonly suggestionTypes: string,
        private readonly suggestionIds: string,
        private readonly interactionTime: number,
        private readonly numberOfPrefixPopCandidates: string,
        private readonly totalSuggestion: string,
    ) {

        super(lob, elementId, "TypeaheadInteraction", activeESSTests);
        this.inputLength = this.userTypedQuery.length;
        if (selectedSuggestion) {
            this.suggestionSelected = true;
            this.selectionDepth = selectedSuggestion.getPosition().toString();
        } else {
            this.suggestionSelected = false;
            this.selectionDepth = "undefined";
        }
    }
}
